// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../types';

type TagProps = {
  large: boolean,
};

const defaultStyle = theme => (css`
  font-size: ${theme.fontSize};
  line-height: 1rem;
  padding: .25rem 1rem;
`);

const largeStyle = theme => (css`
  font-size: ${`calc(${theme.ratioLarge} * ${theme.fontSize})`};
  line-height: calc(1rem * ${theme.ratioLarge});
  padding: ${`calc(.25rem * ${theme.ratioLarge}) calc(1rem * ${theme.ratioLarge})`};
`);

const Tag = styled<any, Theme, TagProps>('span')`
  background-color: ${({ theme: { tags } }) => tags.backgroundColor};
  border-radius: 75rem;
  color: ${({ theme: { tags } }) => tags.color};
  display: inline-block;
  ${({ theme: { tags }, large }) => (large ? largeStyle(tags) : defaultStyle(tags))}

  & + span {
    margin-left: .5rem;
  }
`;

export const TagContainer = styled<any, Theme>('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;

type Props = {
  large?: boolean,
  tags: Array<string>,
};

const Tags = ({
  tags,
  large = false,
}: Props) => (
  <TagContainer>
    {tags && tags.map(tag => (
      <Tag key={tag} large={large}>{tag}</Tag>
    ))}
  </TagContainer>
);

Tags.defaultProps = {
  large: false,
};

export default Tags;
